import MdxWrapper from './MdxWrapper';

export default MdxWrapper;
